import { LayerService } from '@/services/layers/layerService';
import { geoprocessingSelectionHandler } from '@/components/mapTools/geoprocessings/utils/GeoprocessingSelectionHandler';
import { mapService } from '@/services/map/mapService';

export default {
    data() {
        return {
            capas: 'cargadas',
            metodo: 'polygon',
            otrasCapas: false,
            capasSeleccionadas: [], // Stores IDs of selected layers
            dissolve: true,
            emitTimeout: null,
        };
    },
    watch: {
        capas() {
            this.emitState();
        },
        metodo() {
            this.emitState();
        },
        otrasCapas() {
            this.emitState();
        },
        capasSeleccionadas() {
            this.emitState();
        },
        dissolve() {
            this.emitState();
        },
    },
    methods: {
        onModeChange(val) {
            this.otrasCapas = val;
            if (!val) {
                // Switching back to Draw mode
                const map = mapService.get();
                if (map) {
                    geoprocessingSelectionHandler.stopSelection(map);
                }
                
                if (this.capaOtrasSeleccionada) {
                    LayerService.removeLayerByID(this.capaOtrasSeleccionada);
                    geoprocessingSelectionHandler.clearHighlight();
                    this.capaOtrasSeleccionada = '';
                }
            }
        },
        emitState() {
            const payload = this.currentPayload();
            this.$emit('updateGeoprocessingBody', payload);
        },
        getCommonPayload() {
            let finalCapasSeleccionadas = this.capasSeleccionadas;

            if (this.capas === 'cargadas') {
                const activeLayers = this.$store.getters.getActiveLayers || [];
                finalCapasSeleccionadas = activeLayers.map((l) => l.id);
            }

            return {
                capas: this.capas,
                metodo: this.metodo,
                otrasCapas: this.otrasCapas,
                capasSeleccionadas: finalCapasSeleccionadas,
                dissolve: this.dissolve,
            };
        },
        // Default implementation if component doesn't override
        currentPayload() {
            return this.getCommonPayload();
        },
    },
    mounted() {
        this.emitState();
    },
};
